/* tslint:disable */

import * as THREE from 'three';
import {Vector2, Vector3} from "three";

declare var jQuery: any;

declare function drawLine(startPoint, endPoint, color, canvas, opacity): any;

declare function drawString(text, position, color, font, canvas): any;

declare function drawEllipse(position, radiusX, radiusY, color, isFill, canvas, opacity): any;

declare function createCanvasElement(classes): any;

export class TwoDViewVisualizationOptions {

    static SelectedPositionTypes = {
        cross: 1,
        circle: 2
    }
    static labelsOptions = {
        color: '#ffff00',
        show: true,
        font: '10px Arial',
        radius: 20,
        type: {
            cross: true,
            circle: true
        }
    };

    static screenshotsOptions = {
        includeNames: true,
        location: {
            top: true,
            bottom: false
        }
    };

}

export class ImageDrawingInfo {

    imagesDirectories;
    enhancement;
    color;
    isOutline;

    hasOutline; // indicates if the item Marker or Region

    constructor(imagesDirectories: string, color, hasOutline) {
        this.imagesDirectories = imagesDirectories;
        this.color = color;
        this.enhancement = 1;
        this.isOutline = false;
        this.hasOutline = hasOutline;
    }

    getActiveDirectory(twoDView: TwoDView) {
        if (twoDView.type === TwoDView.ViewsTypes.orthogonalViews) {
            return this.getActiveOrthogonalViewDirectory(twoDView.name);
        }
        return this.getActiveMovieViewDirectory(twoDView.name);
    }

    getActiveOrthogonalViewDirectory(orthogonalViewName) {
        // Region
        if (this.hasOutline) {
            if (this.isOutline) {
                return this.imagesDirectories.orthogonal_views[orthogonalViewName].outline;
            }
            return this.imagesDirectories.orthogonal_views[orthogonalViewName].fill;
        } else { //Marker
            return this.imagesDirectories.orthogonal_views[orthogonalViewName];
        }
    }

    getActiveMovieViewDirectory(movieViewName) {
        return this.imagesDirectories.movie_views[movieViewName];
    }

    static getImgSRC(viewFolderURL, layer) {
        return viewFolderURL + '/' + layer.toString() + '.webp';
        // return viewFolderURL + '/' + layer.toString() + '.jpg';
    }
}

export abstract class TwoDView {
    name: string; //dorsal, sagittal , coronal, MovieX, MovieY
    selected: boolean;
    axis: string; // x,y,z
    type: string;//Orthogonal view or Movie view
    imageInfo;

    hasLabels;

    static ViewsTypes = {
        orthogonalViews: 'orthogonal_views',
        movieViews: 'movie_views'
    }

    static ViewsNames: {
        dorsal: 'dorsal',
        sagittal: 'sagittal',
        'coronal': 'coronal',
        x: 'x',
        y: 'y'
    }

    constructor(name: string, axis: string, type: string, imageInfo, hasLabels) {
        this.name = name;
        this.axis = axis;
        this.type = type;
        this.selected = false;
        this.imageInfo = imageInfo;
        this.hasLabels = hasLabels;
    }

    getImageXAxis() {
        return null;
    }

    getImageYAxis() {
        return null;
    }

    getImageZAxis() {
        return null;
    }

    getYIncrementSign() {
        return 1;
    }


    convertCanvasCoordinatesIntoImageCoordinates(canvasCoordinates, imageToCanvasRatio) {
        return null;
    };

    convertImageCoordinatesIntoCanvasCoordinates(imageCoordinates, imageToCanvasRatio) {
        return null;
    };

    convert3DPositionTo2DPosition(node3DPosition, imageToCanvasRatio, canvasHeight) {
        return null;
    };
}

export abstract class OrthogonalView extends TwoDView {

    constructor(name: string, axis: string, imageInfo) {
        super(name, axis, 'orthogonal_views', imageInfo, true);
    }
}

export class DorsalView extends OrthogonalView {
    constructor(imageInfo) {
        super('dorsal', 'z', imageInfo);
    }

    convertCanvasCoordinatesIntoImageCoordinates(canvasCoordinates, imageToCanvasRatio) {
        // x,y and z of image coordinates
        return {
            x: Math.floor(canvasCoordinates.x * imageToCanvasRatio.width),
            y: Math.floor(canvasCoordinates.y * imageToCanvasRatio.height),
            z: null
        };
    }

    convertImageCoordinatesIntoCanvasCoordinates(imageCoordinates, imageToCanvasRatio) {
        // x , y of canvas coordinates
        return {
            x: Math.floor(imageCoordinates.x / imageToCanvasRatio.width),
            y: Math.floor(imageCoordinates.y / imageToCanvasRatio.height),
        };
    }

    convert3DPositionTo2DPosition(position3D, imageToCanvasRatio, canvasHeight = null) {
        return new THREE.Vector3(
            Math.floor(position3D.x / imageToCanvasRatio.width),
            Math.floor(position3D.y / imageToCanvasRatio.height),
            Math.floor(position3D.z)
        )
    }

    getImageXAxis() {
        return 'x';
    }

    getImageYAxis() {
        return 'y';
    }

    getImageZAxis() {
        return 'z';
    }

    getYIncrementSign() {
        return 1;
    }
}

export class SagittalView extends OrthogonalView {
    constructor(imageInfo) {
        super('sagittal', 'x', imageInfo);
    }

    convertCanvasCoordinatesIntoImageCoordinates(canvasCoordinates, imageToCanvasRatio) {
        return {
            x: null,
            y: Math.floor(canvasCoordinates.x * imageToCanvasRatio.width),
            z: this.imageInfo.size.height - Math.floor(canvasCoordinates.y * imageToCanvasRatio.height)
        };
    }

    convertImageCoordinatesIntoCanvasCoordinates(imageCoordinates, imageToCanvasRatio) {
        return {
            x: Math.floor(imageCoordinates.y / imageToCanvasRatio.width),
            y: Math.floor(this.imageInfo.size.height / imageToCanvasRatio.height - Math.floor(imageCoordinates.z / imageToCanvasRatio.height))
        };
    }

    convert3DPositionTo2DPosition(position3D, imageToCanvasRatio, canvasHeight) {
        // return {
        //     x: Math.floor(position3D.y / imageToCanvasRatio.width),
        //     y: canvasHeight - Math.floor(position3D.z / imageToCanvasRatio.height),
        //     layer: Math.floor(position3D.x),
        // };

        return new THREE.Vector3(
            Math.floor(position3D.y / imageToCanvasRatio.width),
            canvasHeight - Math.floor(position3D.z / imageToCanvasRatio.height),
            Math.floor(position3D.x))
    }

    getImageXAxis() {
        return 'y';
    }

    getImageYAxis() {
        return 'z';
    }

    getImageZAxis() {
        return 'x';
    }

    getYIncrementSign() {
        return -1;
    }

}

export class CoronalView extends OrthogonalView {
    constructor(imageInfo) {
        super('coronal', 'y', imageInfo);
    }

    convertCanvasCoordinatesIntoImageCoordinates(canvasCoordinates, imageToCanvasRatio) {
        return {
            x: Math.floor(canvasCoordinates.x * imageToCanvasRatio.width),
            y: null,
            z: this.imageInfo.size.height - Math.floor(canvasCoordinates.y * imageToCanvasRatio.height)
        };
    }

    convertImageCoordinatesIntoCanvasCoordinates(imageCoordinates, imageToCanvasRatio) {
        return {
            x: Math.floor(imageCoordinates.x / imageToCanvasRatio.width),
            y: Math.floor(this.imageInfo.size.height / imageToCanvasRatio.height - Math.floor(imageCoordinates.z / imageToCanvasRatio.height))
        };
    }

    convert3DPositionTo2DPosition(position3D, imageToCanvasRatio, canvasHeight) {

        // return {
        //     x: Math.floor(position3D.x / imageToCanvasRatio.width),
        //     y: canvasHeight - Math.floor(position3D.z / imageToCanvasRatio.height),
        //     layer: Math.floor(position3D.y),
        // };

        return new THREE.Vector3(
            Math.floor(position3D.x / imageToCanvasRatio.width),
            canvasHeight - Math.floor(position3D.z / imageToCanvasRatio.height),
            Math.floor(position3D.y))
    };

    getImageXAxis() {
        return 'x';
    }

    getImageYAxis() {
        return 'z';
    }

    getImageZAxis() {
        return 'y';
    }

    getYIncrementSign() {
        return -1;
    }
}

export class MovieView extends TwoDView {
    constructor(name: string, axis: string, imageInfo) {
        super(name, axis, 'movie_views', imageInfo, false);
    }
}


export class MouseStatus {
    static positionOnCanvas: THREE.Vector2;
    static positionOnScreen: THREE.Vector2;
    static isDown: false;
    static focusedCanvas: null;

    static update(positionOnCanvas, positionOnScreen, activeCanvas, isDown) {
        MouseStatus.focusedCanvas = activeCanvas;
        MouseStatus.positionOnCanvas = positionOnCanvas;
        MouseStatus.positionOnScreen = positionOnScreen;

        if (isDown !== null) {
            MouseStatus.isDown = isDown;
        }
    }
}

export class SelectedPosition {
    // REAL X,Y,Z of the img coordinates in the TIF file
    static coordinates = new Vector3(0, 0, 0);

    static initializeMovieView(movieView: MovieView) {
        SelectedPosition.coordinates[movieView.axis] = 0;
    }

    static initializeOrthogonalViews(position = {x: 0, y: 0, z: 0}, sharedViewHash = '') {
        //If the fragment that is related to sharing the current view is null/empty/undefined then we've to set the initial coordinate values.
        if (!sharedViewHash) {
            this.set({x: 284, y: 974 / 2, z: 358 / 2});
        } else {
            setTimeout(() => {
                this.set(position);
            }, 300);
        }
    }

    static updateCoordinate(coordinateName, value) {
        SelectedPosition.coordinates[coordinateName] = value;
    }

    static adjustCoordinate(view: TwoDView, shift: number) {
        SelectedPosition.coordinates[view.axis] += shift;

        // if (SelectedPosition.coordinates[view.axis] < 0 || SelectedPosition.coordinates[view.axis] == view.imageInfo.size.layers - 1) {
        //     SelectedPosition.coordinates[view.axis] = 0;
        // } else if (SelectedPosition.coordinates[view.axis] > view.imageInfo.size.layers - 1) {
        //     this.coordinates[view.axis] = view.imageInfo.size.layers - 1;
        // }
        if (SelectedPosition.coordinates[view.axis] < 0 || SelectedPosition.coordinates[view.axis] > view.imageInfo.size.layers - 1) {
            SelectedPosition.coordinates[view.axis] = view.imageInfo.size.layers - 1;
        } else if (SelectedPosition.coordinates[view.axis] == view.imageInfo.size.layers - 1) {
            SelectedPosition.coordinates[view.axis] = 0;
        }
    }

    static isAxisCoordinateDefined(coordinate) {
        return coordinate !== null && coordinate !== undefined || coordinate === 0;
    }


    static set(position) {
        if (this.isAxisCoordinateDefined(position.x)) {
            SelectedPosition.coordinates.x = position.x;
        }
        if (this.isAxisCoordinateDefined(position.y)) {
            SelectedPosition.coordinates.y = position.y;
        }
        if (this.isAxisCoordinateDefined(position.z)) {
            SelectedPosition.coordinates.z = position.z;
        }
    }

    static draw(canvas, twoDView: TwoDView, xLabel = '', yLabel = '', layerLabel = '', imageToCanvasRatio) {
        if (TwoDViewVisualizationOptions.labelsOptions.show) {
            let canvasCoordinates = twoDView.convertImageCoordinatesIntoCanvasCoordinates(SelectedPosition.coordinates, imageToCanvasRatio);
            let crossedLines = {
                horizontal: {
                    start: {x: 0, y: canvasCoordinates.y},
                    end: {x: canvas.width, y: canvasCoordinates.y}
                },
                vertical: {
                    start: {x: canvasCoordinates.x, y: 0},
                    end: {x: canvasCoordinates.x, y: canvas.height}
                },
            };


            if (TwoDViewVisualizationOptions.labelsOptions.type.cross) {
                drawLine(crossedLines.horizontal.start, crossedLines.horizontal.end, TwoDViewVisualizationOptions.labelsOptions.color, canvas, 1);
                drawLine(crossedLines.vertical.start, crossedLines.vertical.end, TwoDViewVisualizationOptions.labelsOptions.color, canvas, 1);
            }

            if (TwoDViewVisualizationOptions.labelsOptions.type.circle) {
                drawEllipse(canvasCoordinates,
                    TwoDViewVisualizationOptions.labelsOptions.radius,
                    TwoDViewVisualizationOptions.labelsOptions.radius,
                    TwoDViewVisualizationOptions.labelsOptions.color, false, canvas, 1);
            }

            drawString(yLabel,
                {
                    x: crossedLines.horizontal.start.x + 10,
                    y: crossedLines.horizontal.start.y - 10
                },
                TwoDViewVisualizationOptions.labelsOptions.color,
                TwoDViewVisualizationOptions.labelsOptions.font,
                canvas);

            drawString(xLabel,
                {
                    x: crossedLines.vertical.start.x + 10,
                    y: crossedLines.vertical.start.y + 10
                },
                TwoDViewVisualizationOptions.labelsOptions.color,
                TwoDViewVisualizationOptions.labelsOptions.font,
                canvas);

            drawString(layerLabel,
                {
                    x: crossedLines.vertical.start.x - 40,
                    y: 10
                },
                TwoDViewVisualizationOptions.labelsOptions.color,
                TwoDViewVisualizationOptions.labelsOptions.font,
                canvas);
        }

    }
}

export class ScaleBar {
    static position = new Vector3(10, 10, 0);
    static lengthInMicrons = 100;

    static draw(canvas, twoDView: TwoDView, imageToCanvasRatio) {
        if (TwoDViewVisualizationOptions.labelsOptions.show) {
            let canvasCoordinates = twoDView.convertImageCoordinatesIntoCanvasCoordinates(SelectedPosition.coordinates, imageToCanvasRatio);

            let lineY = canvas.height - ScaleBar.position.y;
            let lineEndX = ScaleBar.lengthInMicrons / imageToCanvasRatio.width + ScaleBar.position.x

            let line = {
                start: {x: ScaleBar.position.x, y: lineY},
                end: {x: lineEndX, y: lineY}
            }

            drawLine(line.start, line.end, TwoDViewVisualizationOptions.labelsOptions.color, canvas, 1);

            let lineLabelY = lineY - 5;
            let label = '100µm'

            drawString(label,
                {
                    x: ScaleBar.position.x,
                    y: lineLabelY
                },
                TwoDViewVisualizationOptions.labelsOptions.color,
                TwoDViewVisualizationOptions.labelsOptions.font,
                canvas);
        }


    }
}

export class Zoom {
    static canvas = null;
    static isZoom = false;
    static options = {
        level: 2,
        canvasSize: 300,
        canvasOffsetFromMouse: {
            x: 50,
            y: 0
        },
        focus: {
            show: true,
            length: 20,
            color: TwoDViewVisualizationOptions.labelsOptions.color
        }
    };

    static init(container) {
        Zoom.canvas = createCanvasElement(['zoom', 'inactive-zoom']);
        Zoom.updateSize();
        container.appendChild(Zoom.canvas);
    }

    static draw(originalCanvas, startX, startY, width, height) {

        let zoomCanvasContext = Zoom.canvas.getContext('2d');
        zoomCanvasContext.drawImage(originalCanvas, startX, startY, width, height, 0, 0, Zoom.options.canvasSize, Zoom.options.canvasSize);

        if (Zoom.options.focus.show) {
            let center = {
                x: Zoom.options.canvasSize / 2,
                y: Zoom.options.canvasSize / 2
            };

            let horizontalLine = {
                start: {
                    x: center.x - Zoom.options.focus.length / 2,
                    y: center.y
                },
                end: {
                    x: center.x + Zoom.options.focus.length / 2,
                    y: center.y
                }
            };

            let verticalLine = {
                start: {
                    x: center.x,
                    y: center.y - Zoom.options.focus.length / 2
                },
                end: {
                    x: center.x,
                    y: center.y + Zoom.options.focus.length / 2
                }
            };

            drawLine(horizontalLine.start, horizontalLine.end, Zoom.options.focus.color, Zoom.canvas, 1);
            drawLine(verticalLine.start, verticalLine.end, Zoom.options.focus.color, Zoom.canvas, 1);
        }
    };

    static update(isZoom) {
        if (isZoom !== null) {
            Zoom.isZoom = isZoom;
        }

        if (Zoom.isZoom) {
            Zoom.canvas.classList.add('active-zoom');
            Zoom.canvas.classList.remove('inactive-zoom');

            let startZoomingAreaLeft = MouseStatus.positionOnCanvas.x - (Zoom.options.canvasSize) / Zoom.options.level + (Zoom.options.canvasSize) / (2 * Zoom.options.level);
            let startZoomingAreaTop = MouseStatus.positionOnCanvas.y - (Zoom.options.canvasSize) / Zoom.options.level + (Zoom.options.canvasSize) / (2 * Zoom.options.level);

            let zoomCanvasPositionLeft = MouseStatus.positionOnScreen.x - Zoom.options.canvasSize - Zoom.options.canvasOffsetFromMouse.x;
            let zoomCanvasPositionTop = MouseStatus.positionOnScreen.y - Zoom.options.canvasSize / 2 - Zoom.options.canvasOffsetFromMouse.y;

            Zoom.canvas.style.left = zoomCanvasPositionLeft.toString() + 'px';
            Zoom.canvas.style.top = zoomCanvasPositionTop.toString() + 'px';

            if (MouseStatus.focusedCanvas !== null) {
                Zoom.draw(MouseStatus.focusedCanvas,
                    startZoomingAreaLeft,
                    startZoomingAreaTop,
                    Zoom.options.canvasSize / Zoom.options.level,
                    Zoom.options.canvasSize / Zoom.options.level);
            }
        } else {
            Zoom.canvas.classList.remove('active-zoom');
            Zoom.canvas.classList.add('inactive-zoom');
        }
    }

    static updateSize() {
        Zoom.canvas.width = Zoom.options.canvasSize;
        Zoom.canvas.height = Zoom.options.canvasSize;
    }
}
